var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6363 1.36358C21.9878 1.71505 21.9878 2.2849 21.6363 2.63637L20.2727 3.99998L22.6363 6.36358C22.9878 6.71505 22.9878 7.2849 22.6363 7.63637L19.1363 11.1364C18.7848 11.4878 18.215 11.4878 17.8635 11.1364L15.4999 8.77277L12.6214 11.6512C12.947 12.0795 13.2181 12.548 13.4274 13.0462C13.7543 13.8244 13.9241 14.6595 13.9269 15.5036C13.9297 16.3477 13.7656 17.1839 13.4439 17.9643C13.1222 18.7447 12.6493 19.4537 12.0524 20.0505C11.4556 20.6474 10.7466 21.1203 9.96621 21.442C9.18585 21.7637 8.34957 21.9278 7.5055 21.925C6.66144 21.9222 5.82627 21.7524 5.04809 21.4255C4.2699 21.0986 3.56407 20.6209 2.97124 20.0201L2.96449 20.0133C1.79868 18.8062 1.15363 17.1895 1.16821 15.5114C1.18279 13.8334 1.85587 12.2282 3.04249 11.0416C4.2291 9.85497 5.8343 9.18188 7.51236 9.1673C8.89248 9.15531 10.2311 9.58953 11.3344 10.3927L20.3635 1.36358C20.715 1.01211 21.2848 1.01211 21.6363 1.36358ZM18.9999 5.27277L16.7727 7.49998L18.4999 9.22718L20.7271 6.99998L18.9999 5.27277ZM7.49988 20C9.98516 20 11.9999 17.9853 11.9999 15.5C11.9999 13.0147 9.98516 11 7.49988 11C5.0146 11 2.99988 13.0147 2.99988 15.5C2.99988 17.9853 5.0146 20 7.49988 20Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/Key.9055612b089a7ed8aa7b6ac19fa23ff5.svg";
export { ForwardRef as ReactComponent };